import swal from 'sweetalert'

import router from "../../router";

export {get_request} from './get'
export {post_request} from './post'

export {fields} from './fields'
export {form_methods} from './form_methods'

export const requests_methods = {

    methods: {
        redirect(val){

            if(val){
                this.$store.commit('remove_from_passed_stages',val)
                this.$store.commit('push_to_allowed_stages',val)
                router.push({ name: val})
            }

        }
    }

}

export const validation = {
    methods: {
        show_errors(error){
            if(typeof error.response['data']['errors'] != 'undefined'){
                let errors_list = []
                for(let k in error.response['data']['errors']){
                    errors_list.push({field: k, status: error.response['data']['errors'][k]});
                }

                this.show_modal(errors_list[0].status[0])

            }else{
                this.show_modal('ERROR')
            }
            //TODO
            // this.save_data('loader',false)
        },
        show_modal(text, css_class = 'no-class', title=''){
            let scope = this;
            swal({
                title: title,
                text: text,
                className: css_class,
                // onOpen: scope.save_data('modal_open', true) //TODO

            }).then(()=>{
                //TODO
                // this.save_data('modal_open', false);
            })

        }
    }
}


